module.exports = __webpack_public_path__ + "img/inspiration-1.cf92e78.jpg";